<div class="main placement-card scrollbar-custom">
    <div class="main-title">
        <ng-container *appHasRole="['Admin', 'Farm manager']">
            <h1>
                {{
                    placementForm.get('id')?.value === 0
                        ? 'New Cycle'
                        : 'Feeding Program'
                }}
            </h1>
            <p>
                {{
                    placementForm.get('id')?.value === 0
                        ? 'Create New Cycle'
                        : 'Edit Feeding Program'
                }}
            </p>
        </ng-container>
    </div>
    <form [formGroup]="placementForm" (ngSubmit)="onSubmit()">
        <div class="generatl-info" *ngIf="isVisible">
            <h2 class="section-title">General Information</h2>
            <div class="col-general-info">
                <div class="col-top-left">
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label
                                >Cycle Name<span class="text-danger-required"
                                    >*</span
                                ></label
                            >
                            <input
                                class="form-control"
                                formControlName="flockNo"
                                placeholder="EX: KL-334"
                                [ngClass]="{
                                    'is-invalid': isControlInvalid('flockNo'),
                                    'is-valid':
                                        !isControlInvalid('flockNo') &&
                                        placementForm.get('flockNo').touched
                                }"
                            />
                            <div
                                *ngIf="
                                    placementForm.get('flockNo').invalid &&
                                    placementForm.get('flockNo').touched
                                "
                                class="text-danger"
                            >
                                Please select a Cycle Name
                            </div>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label
                                >Farm<span class="text-danger-required"
                                    >*</span
                                ></label
                            >
                            <select
                                (change)="onFarmChange($event.target.value)"
                                formControlName="farmId"
                                class="form-control"
                                [ngClass]="{
                                    'is-invalid': isControlInvalid('farmId'),
                                    'is-valid':
                                        !isControlInvalid('farmId') &&
                                        placementForm.get('farmId').touched
                                }"
                            >
                                <option value="" disabled selected>
                                    Select
                                </option>
                                <option
                                    *ngFor="let farm of farmlist"
                                    [value]="farm.id"
                                >
                                    {{ farm.name }}
                                </option>
                            </select>
                            <div
                                *ngIf="
                                    placementForm.get('farmId').invalid &&
                                    placementForm.get('farmId').touched
                                "
                                class="text-danger"
                            >
                                Please select a Farm.
                            </div>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label
                                >Supplier<span class="text-danger-required"
                                    >*</span
                                ></label
                            >

                            <select
                                formControlName="supplierId"
                                class="form-control"
                                [ngClass]="{
                                    'is-invalid':
                                        isControlInvalid('supplierId'),
                                    'is-valid':
                                        !isControlInvalid('supplierId') &&
                                        placementForm.get('supplierId').touched
                                }"
                            >
                                <option value="" disabled selected>
                                    Select
                                </option>
                                <option
                                    *ngFor="let suppier of supplierList"
                                    [value]="suppier.id"
                                >
                                    {{ suppier.name }}
                                </option>
                            </select>
                            <div
                                *ngIf="
                                    placementForm.get('supplierId').invalid &&
                                    placementForm.get('supplierId').touched
                                "
                                class="text-danger"
                            >
                                Please select a Supplier.
                            </div>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label
                                >Cycle Start Date/Time<span
                                    class="text-danger-required"
                                    >*</span
                                ></label
                            >
                            <input
                                class="form-control"
                                formControlName="placementDateTime"
                                type="datetime-local"
                                placeholder="Select cycle start date and time"
                                [ngClass]="{
                                    'is-invalid':
                                        isControlInvalid('placementDateTime'),
                                    'is-valid':
                                        !isControlInvalid(
                                            'placementDateTime'
                                        ) &&
                                        placementForm.get('placementDateTime')
                                            .touched
                                }"
                            />
                            <div
                                *ngIf="
                                    placementForm.get('placementDateTime')
                                        .invalid &&
                                    placementForm.get('placementDateTime')
                                        .touched
                                "
                                class="text-danger"
                            >
                                <span
                                    *ngIf="
                                        placementForm
                                            .get('placementDateTime')
                                            .hasError('required')
                                    "
                                >
                                    Select Cycle date time.
                                </span>
                            </div>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label
                                >Expected Start Selling Date<span
                                    class="text-danger-required"
                                    >*</span
                                ></label
                            >
                            <input
                                class="form-control"
                                formControlName="expectedStartSellingDate"
                                type="date"
                                placeholder="Select expected start selling date"
                                [ngClass]="{
                                    'is-invalid': isControlInvalid(
                                        'expectedStartSellingDate'
                                    ),
                                    'is-valid':
                                        !isControlInvalid(
                                            'expectedStartSellingDate'
                                        ) &&
                                        placementForm.get(
                                            'expectedStartSellingDate'
                                        ).touched
                                }"
                            />
                            <div
                                *ngIf="
                                    placementForm.get(
                                        'expectedStartSellingDate'
                                    ).invalid &&
                                    placementForm.get(
                                        'expectedStartSellingDate'
                                    ).touched
                                "
                                class="text-danger"
                            >
                                <span
                                    *ngIf="
                                        placementForm
                                            .get('expectedStartSellingDate')
                                            .hasError('required')
                                    "
                                >
                                    Select expected start selling date.
                                </span>
                                <span
                                    *ngIf="
                                        placementForm
                                            .get('expectedStartSellingDate')
                                            .hasError(
                                                'expectedStartAfterPlacement'
                                            )
                                    "
                                >
                                    Expected start selling date must be after
                                    placement date.
                                </span>
                            </div>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label
                                >Expected End Selling Date<span
                                    class="text-danger-required"
                                    >*</span
                                ></label
                            >
                            <input
                                class="form-control"
                                formControlName="expectedEndSellingDate"
                                type="date"
                                placeholder="Select expected end selling date"
                                [ngClass]="{
                                    'is-invalid': isControlInvalid(
                                        'expectedEndSellingDate'
                                    ),
                                    'is-valid':
                                        !isControlInvalid(
                                            'expectedEndSellingDate'
                                        ) &&
                                        placementForm.get(
                                            'expectedEndSellingDate'
                                        ).touched
                                }"
                            />
                            <div
                                *ngIf="
                                    placementForm.get('expectedEndSellingDate')
                                        .invalid &&
                                    placementForm.get('expectedEndSellingDate')
                                        .touched
                                "
                                class="text-danger"
                            >
                                <span
                                    *ngIf="
                                        placementForm
                                            .get('expectedEndSellingDate')
                                            .hasError('required')
                                    "
                                >
                                    Select expected end selling date.
                                </span>
                                <span
                                    *ngIf="
                                        placementForm
                                            .get('expectedEndSellingDate')
                                            .hasError('expectedEndAfterStart')
                                    "
                                >
                                    Expected end selling date must be after
                                    expected start selling date.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-top-right">
                    <div formArrayName="placementHousePartition">
                        <div
                            class="row"
                            *ngFor="
                                let partition of placementHousePartition.controls;
                                let i = index
                            "
                            [formGroupName]="i"
                        >
                            <div class="col-md-6 mb-3">
                                <label>
                                    House
                                    <span class="text-danger-required">*</span>
                                </label>
                                <select
                                    class="form-control"
                                    formControlName="farmhouseId"
                                    (change)="
                                        onFarmHouseChange(
                                            $event.target.value,
                                            i
                                        )
                                    "
                                >
                                    <option value="" disabled>Select</option>
                                    <option
                                        *ngFor="
                                            let farmhouse of availableFarmhouses
                                        "
                                        [value]="farmhouse.id"
                                        [disabled]="
                                            selectedFarmhouses.has(farmhouse.id)
                                        "
                                    >
                                        {{ farmhouse.name }}
                                    </option>
                                </select>
                                <div
                                    *ngIf="
                                        partition.get('farmhouseId').invalid &&
                                        partition.get('farmhouseId').touched
                                    "
                                    class="text-danger"
                                >
                                    Please select a Farm House.
                                </div>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>
                                    Partition
                                    <span class="text-danger-required">*</span>
                                </label>
                                <p-multiSelect
                                    formControlName="partitionIds"
                                    [options]="partitionlist[i]"
                                    optionLabel="name"
                                    optionValue="id"
                                    [placeholder]="'Select'"
                                    filterPlaceHolder="Search partition..."
                                    [showToggleAll]="true"
                                    [filter]="true"
                                ></p-multiSelect>
                                <div
                                    *ngIf="
                                        partition.get('partitionIds').invalid &&
                                        partition.get('partitionIds').touched
                                    "
                                    class="text-danger"
                                >
                                    Please select a Partition.
                                </div>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>
                                    Chicks Quantity
                                    <span class="text-danger-required">*</span>
                                </label>
                                <input
                                    class="form-control"
                                    formControlName="houseChicksQty"
                                    type="number"
                                    placeholder="EX. 10000"
                                    [ngClass]="{
                                        'is-invalid':
                                            partition.get('houseChicksQty')
                                                ?.invalid &&
                                            partition.get('houseChicksQty')
                                                ?.touched,
                                        'is-valid':
                                            partition.get('houseChicksQty')
                                                ?.valid &&
                                            partition.get('houseChicksQty')
                                                ?.touched
                                    }"
                                />
                                <div
                                    *ngIf="
                                        partition.get('houseChicksQty')
                                            ?.touched &&
                                        partition.get('houseChicksQty')?.invalid
                                    "
                                    class="text-danger"
                                >
                                    <span
                                        *ngIf="
                                            partition.get('houseChicksQty')
                                                ?.errors?.['required']
                                        "
                                    >
                                        Chicks Quantity is required.
                                    </span>
                                    <span
                                        *ngIf="
                                            partition.get('houseChicksQty')
                                                ?.errors?.['min']
                                        "
                                    >
                                        Chicks Quantity must be non-negative.
                                    </span>
                                </div>
                            </div>
                            <div
                                class="col-md-12 mb-3"
                                *ngIf="
                                    placementHousePartition.controls.length > 1
                                "
                            >
                                <div class="text-right">
                                    <button
                                        class="btn-delete"
                                        type="button"
                                        (click)="removeHousePartition(i)"
                                        title="Remove this house/partition"
                                    >
                                        <i class="fas fa-trash"></i> Remove
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="text-right">
                            <button
                                class="text-right btn-action"
                                type="button"
                                (click)="addHousePartition()"
                            >
                                <i class="fas fa-plus"></i> Add house
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="chicks-info" *ngIf="isVisible">
            <h2 class="section-title">Chicks Information</h2>

            <div class="chicks-form-grid">
                <div class="input-group-chicks">
                    <label
                        >Breed<span class="text-danger-required">*</span></label
                    >
                    <select
                        formControlName="breedId"
                        class="form-control"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('breedId'),
                            'is-valid':
                                !isControlInvalid('breedId') &&
                                placementForm.get('breedId').touched
                        }"
                    >
                        <option value="" disabled selected>Select</option>
                        <option *ngFor="let breed of breeds" [value]="breed.id">
                            {{ breed.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            placementForm.get('breedId').invalid &&
                            placementForm.get('breedId').touched
                        "
                        class="text-danger"
                    >
                        Please select a Breed.
                    </div>
                </div>

                <div class="input-group-chicks">
                    <label
                        >Target Weight (gram)<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        class="form-control"
                        formControlName="targetWeight"
                        type="number"
                        placeholder="Enter target weight"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('targetWeight'),
                            'is-valid':
                                !isControlInvalid('targetWeight') &&
                                placementForm.get('targetWeight').touched
                        }"
                    />
                    <div
                        *ngIf="
                            placementForm.get('targetWeight').touched &&
                            placementForm.get('targetWeight').invalid
                        "
                        class="text-danger"
                    >
                        <span
                            *ngIf="
                                placementForm.get('targetWeight').errors
                                    ?.required
                            "
                            >Target Weight is required.</span
                        >
                        <span
                            *ngIf="
                                placementForm.get('targetWeight').errors?.min
                            "
                            >Target Weight must be non-negative.</span
                        >
                    </div>
                </div>

                <div class="input-group-chicks">
                    <label
                        >Chicks Number<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        class="form-control"
                        formControlName="qty"
                        type="number"
                        placeholder="Calculated from house quantities"
                        readonly
                        [ngClass]="{
                            'is-invalid': isControlInvalid('qty'),
                            'is-valid':
                                !isControlInvalid('qty') &&
                                placementForm.get('qty').touched
                        }"
                    />
                    <div
                        *ngIf="
                            placementForm.get('qty').touched &&
                            placementForm.get('qty').invalid
                        "
                        class="text-danger"
                    >
                        <span *ngIf="placementForm.get('qty').errors?.required"
                            >Quantity is required.</span
                        >
                        <span *ngIf="placementForm.get('qty').errors?.min"
                            >Quantity must be non-negative.</span
                        >
                    </div>
                </div>

                <div class="input-group-chicks">
                    <label
                        >Parent Stock Age (Days)<span
                            class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        class="form-control"
                        formControlName="parentStockAge"
                        type="number"
                        placeholder="Enter age in days"
                    />
                </div>

                <div class="input-group-chicks">
                    <label
                        >Hatchery Vaccination<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <select
                        formControlName="vaccineId"
                        class="form-control"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('vaccineId'),
                            'is-valid':
                                !isControlInvalid('vaccineId') &&
                                placementForm.get('vaccineId').touched
                        }"
                    >
                        <option value="" disabled selected>Select</option>
                        <option
                            *ngFor="let vaccine of vaccines"
                            [value]="vaccine.id"
                        >
                            {{ vaccine.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            placementForm.get('vaccineId').invalid &&
                            placementForm.get('vaccineId').touched
                        "
                        class="text-danger"
                    >
                        Please select a Vaccination.
                    </div>
                </div>

                <div class="input-group-chicks">
                    <label
                        >Litter Type<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <select
                        formControlName="litterTypeId"
                        class="form-control"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('litterTypeId'),
                            'is-valid':
                                !isControlInvalid('litterTypeId') &&
                                placementForm.get('litterTypeId').touched
                        }"
                    >
                        <option value="" disabled selected>Select</option>
                        <option
                            *ngFor="let litter of litters"
                            [value]="litter.id"
                        >
                            {{ litter.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            placementForm.get('litterTypeId').invalid &&
                            placementForm.get('litterTypeId').touched
                        "
                        class="text-danger"
                    >
                        Please select a Litter Type.
                    </div>
                </div>

                <!-- Empty div to fill the grid if needed -->
                <div class="input-group-chicks"></div>
            </div>
        </div>

        <div class="feed-program">
            <h2 class="section-title">Feeding Program</h2>
            <div formArrayName="placementChicksFeedingProgram">
                <table class="feeding-program-table responsive">
                    <tr>
                        <th>Stage</th>
                        <th>Age From (days)</th>
                        <th>Age To (days)</th>
                        <th>Quantity (gram/day)</th>
                    </tr>
                    <tr
                        *ngFor="
                            let feedingProgram of placementChicksFeedingProgram.controls;
                            let i = index
                        "
                        [formGroupName]="i"
                    >
                        <td>
                            <label>{{
                                feedingProgram.value.stageId | stageName
                            }}</label>
                            <span
                                class="text-danger-required"
                                *ngIf="feedingProgram.value.stageId !== 1"
                                >*</span
                            >
                        </td>
                        <td>
                            <input
                                class="form-control"
                                formControlName="agefrom"
                                type="number"
                                placeholder="Enter starting age"
                            />
                            <div
                                *ngIf="
                                    feedingProgram.get('agefrom').touched &&
                                    feedingProgram.get('agefrom').invalid
                                "
                            >
                                <small
                                    class="text-danger"
                                    *ngIf="
                                        feedingProgram.get('agefrom').errors
                                            ?.required
                                    "
                                    >Age from is required.</small
                                >
                                <small
                                    class="text-danger"
                                    *ngIf="
                                        feedingProgram.get('agefrom').errors
                                            ?.min
                                    "
                                    >Age from must be non-negative.</small
                                >
                            </div>
                        </td>
                        <td>
                            <input
                                class="form-control"
                                formControlName="ageTo"
                                type="number"
                                placeholder="Enter ending age"
                            />
                            <div
                                *ngIf="
                                    feedingProgram.get('ageTo').touched &&
                                    feedingProgram.get('ageTo').invalid
                                "
                            >
                                <small
                                    class="text-danger"
                                    *ngIf="
                                        feedingProgram.get('ageTo').errors
                                            ?.required
                                    "
                                    >Age to is required.</small
                                >
                                <small
                                    class="text-danger"
                                    *ngIf="
                                        feedingProgram.get('ageTo').errors?.min
                                    "
                                    >Age from must be non-negative.</small
                                >
                            </div>
                            <div
                                class="text-danger"
                                *ngIf="
                                    feedingProgram.get('agefrom').valid &&
                                    feedingProgram.get('ageTo').dirty &&
                                    feedingProgram.get('agefrom').value >
                                        feedingProgram.get('ageTo').value
                                "
                            >
                                Age to must be greater than age from
                            </div>
                        </td>
                        <td
                            [ngClass]="{
                                'input-error-main':
                                    feedingProgram.get('chicksQty').errors?.min
                            }"
                        >
                            <input
                                class="form-control"
                                formControlName="chicksQty"
                                type="number"
                                placeholder="Enter quantity per day"
                            />
                            <div
                                *ngIf="
                                    feedingProgram.get('chicksQty').touched &&
                                    feedingProgram.get('chicksQty').invalid
                                "
                            >
                                <small
                                    class="text-danger"
                                    *ngIf="
                                        feedingProgram.get('chicksQty').errors
                                            ?.required
                                    "
                                    >Chicks quantity is required.</small
                                >
                                <small
                                    class="text-danger"
                                    *ngIf="
                                        feedingProgram.get('chicksQty').errors
                                            ?.min
                                    "
                                    >Chicks quantity must be
                                    non-negative.</small
                                >
                            </div>
                        </td>
                        <!-- Assuming you have a pipe to display the stage names -->
                    </tr>
                </table>
            </div>
        </div>

        <div class="disinfection-program" *ngIf="isVisible">
            <h2 class="section-title">Disinfection Program</h2>
            <div class="row">
                <div class="col-md-4 mb-3">
                    <label
                        >Disinfection Program<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <select
                        formControlName="disInfectionProgramId"
                        class="form-control"
                        [ngClass]="{
                            'is-invalid': isControlInvalid(
                                'disInfectionProgramId'
                            ),
                            'is-valid':
                                !isControlInvalid('disInfectionProgramId') &&
                                placementForm.get('disInfectionProgramId')
                                    .touched
                        }"
                    >
                        <option value="" disabled selected>Select</option>
                        <option
                            *ngFor="let disinfection of disInfections"
                            [value]="disinfection.id"
                        >
                            {{ disinfection.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            placementForm.get('disInfectionProgramId')
                                .invalid &&
                            placementForm.get('disInfectionProgramId').touched
                        "
                        class="text-danger"
                    >
                        Please select a disinfection program.
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <label
                        >Disinfection Start Date/Time<span
                            class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        class="form-control"
                        formControlName="disInfectionProgramStartDate"
                        type="datetime-local"
                        placeholder="Select disinfection start date and time"
                        [ngClass]="{
                            'is-invalid': isControlInvalid(
                                'disInfectionProgramStartDate'
                            ),
                            'is-valid':
                                !isControlInvalid('disInfectionProgramStartDate') &&
                                placementForm.get('disInfectionProgramStartDate')
                                    .touched
                        }"
                    />
                    <div
                        *ngIf="
                            placementForm.get('disInfectionProgramStartDate')
                                .invalid &&
                            placementForm.get('disInfectionProgramStartDate').touched
                        "
                        class="text-danger"
                    >
                        <span
                            *ngIf="
                                placementForm
                                    .get('disInfectionProgramStartDate')
                                    .hasError('required')
                            "
                        >
                            Disinfection start date/time is required.
                        </span>
                        <span
                            *ngIf="
                                placementForm
                                    .get('disInfectionProgramStartDate')
                                    .hasError(
                                        'disinfectionStartBeforePlacement'
                                    )
                            "
                        >
                            Disinfection start date must be before the cycle
                            start date.
                        </span>
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <label
                        >Disinfection End Date/Time<span
                            class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        class="form-control"
                        formControlName="disInfectionProgramEndDate"
                        type="datetime-local"
                        placeholder="Select disinfection end date and time"
                        [ngClass]="{
                            'is-invalid': isControlInvalid(
                                'disInfectionProgramEndDate'
                            ),
                            'is-valid':
                                !isControlInvalid('disInfectionProgramEndDate') &&
                                placementForm.get('disInfectionProgramEndDate').touched
                        }"
                    />
                    <div
                        *ngIf="
                            placementForm.get('disInfectionProgramEndDate').invalid &&
                            placementForm.get('disInfectionProgramEndDate').touched
                        "
                        class="text-danger"
                    >
                        <span
                            *ngIf="
                                placementForm
                                    .get('disInfectionProgramEndDate')
                                    .hasError('required')
                            "
                        >
                            Disinfection end date/time is required.
                        </span>
                        <span
                            *ngIf="
                                placementForm
                                    .get('disInfectionProgramEndDate')
                                    .hasError('disinfectionEndAfterStart')
                            "
                        >
                            Disinfection end date must be after the disinfection
                            start date.
                        </span>
                        <span
                            *ngIf="
                                placementForm
                                    .get('disInfectionProgramEndDate')
                                    .hasError('disinfectionEndBeforePlacement')
                            "
                        >
                            Disinfection end date must be before the cycle start
                            date.
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="trip-info" *ngIf="isVisible">
            <h2 class="section-title">Trip Information</h2>
            <div class="row">
                <div class="col-md-4 mb-3">
                    <label
                        >Vehicle Temperature(degrees)<span
                            class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        class="form-control"
                        formControlName="venhicleTempeature"
                        type="number"
                        placeholder="Enter temperature in degrees"
                        [ngClass]="{
                            'is-invalid':
                                isControlInvalid('venhicleTempeature'),
                            'is-valid':
                                !isControlInvalid('venhicleTempeature') &&
                                placementForm.get('venhicleTempeature').touched
                        }"
                    />
                    <div
                        *ngIf="
                            placementForm.get('venhicleTempeature').invalid &&
                            placementForm.get('venhicleTempeature').touched
                        "
                        class="text-danger"
                    >
                        Please select a Temperature.
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <label
                        >Vehicle Humidity(%)<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        class="form-control"
                        formControlName="venhicleHumidity"
                        type="number"
                        placeholder="Enter humidity percentage"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('venhicleHumidity'),
                            'is-valid':
                                !isControlInvalid('venhicleHumidity') &&
                                placementForm.get('venhicleHumidity').touched
                        }"
                    />
                    <div
                        *ngIf="
                            placementForm.get('venhicleHumidity').invalid &&
                            placementForm.get('venhicleHumidity').touched
                        "
                        class="text-danger"
                    >
                        Please select a Humidity.
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <label
                        >Stopping Time<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        class="form-control"
                        formControlName="stoppingTime"
                        type="number"
                        placeholder="Enter stopping time in hours"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('stoppingTime'),
                            'is-valid':
                                !isControlInvalid('stoppingTime') &&
                                placementForm.get('stoppingTime').touched
                        }"
                    />
                    <div
                        *ngIf="
                            placementForm.get('stoppingTime').invalid &&
                            placementForm.get('stoppingTime').touched
                        "
                        class="text-danger"
                    >
                        Please select a Stopping Time.
                    </div>
                </div>
                <div class="col-md-6 mb-3">
                    <label
                        >Chicks Trip Time<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        class="form-control"
                        formControlName="chicksTripTime"
                        type="datetime-local"
                        placeholder="Select chicks trip date and time"
                        [ngClass]="{
                            'is-invalid': isControlInvalid('chicksTripTime'),
                            'is-valid':
                                !isControlInvalid('chicksTripTime') &&
                                placementForm.get('chicksTripTime').touched
                        }"
                    />
                    <div
                        *ngIf="
                            placementForm.get('chicksTripTime').invalid &&
                            placementForm.get('chicksTripTime').touched
                        "
                        class="text-danger"
                    >
                        Please select Chicks Trip Time.
                    </div>
                </div>
            </div>
        </div>

        <div class="add-placement-btn text-center mt-4">
            <button
                type="submit"
                class="btn btn-action-primary"
                [disabled]="isLoading$ | async"
            >
                <span *ngIf="!isAuthLoading">
                    {{
                        placementForm.get('id')?.value === 0
                            ? 'Create Placement'
                            : 'Update Feeding
          Program'
                    }}</span
                >
                <span *ngIf="isAuthLoading">Submitting...</span>
            </button>
            <img
                *ngIf="isLoading$ | async"
                src="assets/img/loader.gif"
                alt="Loading..."
                class="loader-image mt-2"
            />
            <!-- <button class="btn btn-primary" type="submit">Create</button> -->
        </div>
    </form>
</div>
